/**
 * Centralised strings for the UTR (no-VAN) wallet "Send UTR for Approval" flow,
 * following the project's `src/app/models/<feature>.constants.ts` convention.
 * No user-facing string in the UTR components/templates should be hardcoded;
 * reference these instead.
 */
export const UTR_WALLET_CONSTANTS = {
  // Dialog
  DIALOG_HEADER: 'Send UTR for Approval',

  // Field labels
  LABEL_UTR_NUMBER: 'UTR Number',
  LABEL_AMOUNT: 'Amount',
  LABEL_PAYMENT_DATE: 'Payment Date',
  LABEL_PAYMENT_MODE: 'Payment Mode',
  LABEL_TRANSACTION_REFERENCE: 'Transaction Reference',
  LABEL_REMARKS: 'Remarks',
  LABEL_PROOF_IMAGE: 'User Image / Payment Proof',

  // Placeholders
  PLACEHOLDER_UTR_NUMBER: 'e.g. 2401231234567890',
  PLACEHOLDER_AMOUNT: '0.00',
  PLACEHOLDER_PAYMENT_MODE: 'Select mode',
  PLACEHOLDER_TRANSACTION_REFERENCE: 'Bank reference (optional)',
  PLACEHOLDER_REMARKS: 'Note for finance (optional)',

  // Customer recharge limits (hosted checkout and UTR)
  RECHARGE_MIN_AMOUNT: 1,
  RECHARGE_MAX_AMOUNT: 10000,
  RECHARGE_STEP: 0.01,
  AMOUNT_RANGE_HINT: 'Maximum wallet recharge amount is ₹10,000.',
  SUMMARY_LIMIT_EXCEEDED: 'Recharge limit exceeded',
  SUMMARY_INVALID_AMOUNT: 'Invalid amount',
  DETAIL_LIMIT_EXCEEDED: 'Maximum wallet recharge amount is ₹10,000.',
  HOSTED_AMOUNT_REQUIRED: 'Amount is required.',
  HOSTED_AMOUNT_MIN: 'Minimum amount is ₹1.',
  HOSTED_AMOUNT_MAX: 'Maximum wallet recharge amount is ₹10,000.',
  AMOUNT_EXCEEDS_LIMIT: 'Amount exceeds the maximum recharge limit.',

  // Buttons
  BTN_CANCEL: 'Cancel',
  BTN_SUBMIT: 'Submit',
  BTN_SUBMITTING: 'Submitting...',

  // Location and evidence
  LOCATION_CAPTURED_PREFIX: 'Location captured:',
  LOCATION_CAPTURING: 'Capturing your location...',
  LOCATION_REQUIRED: 'Your precise location is required to submit this UTR.',
  LOCATION_DENIED:
    'Location permission was denied. Enable it in your browser site settings and retry.',
  LOCATION_UNAVAILABLE: 'Your location is unavailable. Move to an open area and retry.',
  LOCATION_TIMEOUT: 'Location capture timed out. Please retry.',
  LOCATION_UNSUPPORTED: 'Location is not supported by this browser.',
  BTN_RETRY_LOCATION: 'Retry Location',
  PROOF_REQUIRED: 'Capture or select a user image/payment proof before submitting.',
  PROOF_INVALID: 'Please select a valid JPEG, PNG, or WebP image up to 5 MB.',
  PROOF_SELECTED: 'Image captured and ready to submit.',
  IMAGE_ACCEPT: 'image/jpeg,image/png,image/webp',
  MAX_IMAGE_SIZE: 5 * 1024 * 1024,

  // Payment-mode dropdown options
  PAYMENT_MODE_OPTIONS: [
    { label: 'NEFT', value: 'NEFT' },
    { label: 'IMPS', value: 'IMPS' },
    { label: 'RTGS', value: 'RTGS' },
    { label: 'UPI', value: 'UPI' },
  ],

  // Toast severities
  SEVERITY_SUCCESS: 'success',
  SEVERITY_WARN: 'warn',
  SEVERITY_ERROR: 'error',

  // Toast: validation
  SUMMARY_MISSING_DETAILS: 'Missing details',
  DETAIL_MISSING_DETAILS: 'UTR number and a valid amount are required.',
  SUMMARY_EVIDENCE_REQUIRED: 'Audit evidence required',

  // Toast: submit outcomes
  SUMMARY_SUBMITTED: 'Submitted',
  DETAIL_SUBMITTED: 'UTR sent for approval. It will show as "Waiting for Approval".',
  SUMMARY_COULD_NOT_SUBMIT: 'Could not submit UTR',
  SUMMARY_SUBMISSION_FAILED: 'Submission failed',
  DETAIL_TRY_AGAIN: 'Please try again.',

  // Multipart form field keys sent to the backend
  FORM_ACCOUNT_ID: 'account_id',
  FORM_UTR_NUMBER: 'utr_number',
  FORM_AMOUNT: 'amount',
  FORM_PAYMENT_DATE: 'payment_date',
  FORM_PAYMENT_MODE: 'payment_mode',
  FORM_TRANSACTION_REFERENCE: 'transaction_reference',
  FORM_REMARKS: 'remarks',
  FORM_LATITUDE: 'latitude',
  FORM_LONGITUDE: 'longitude',
  FORM_ACCURACY: 'accuracy',
  FORM_PROOF_IMAGE: 'proof_image',

  // Response
  RESPONSE_SUCCESS_STATUS: 200,
};
